import React, { useEffect } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import {useDocTitle} from '../components/CustomHook';
import { Link } from 'react-router-dom';

const ITConsulting = () => {
    useDocTitle('NexAI Solution | IT Consulting')

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div>
                <NavBar />
            </div>
            
            <div className="flex flex-col justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
                <div className="container mx-auto px-4 lg:px-20" data-aos="zoom-in">
                    <h1 className="text-5xl font-bold text-center text-blue-900 mb-6">IT Consulting</h1>
                    <div className='flex justify-center mb-12'>
                        <div className='w-24 border-b-4 border-blue-900'></div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                        <div className="bg-white p-8 rounded-2xl shadow-2xl">
                            <h2 className="text-3xl font-semibold text-blue-900 mb-6">Strategic Planning</h2>
                            <p className="text-gray-600 mb-6 text-lg">
                                Expert guidance to align your technology initiatives with business objectives.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">Technology Assessment</h3>
                                        <p className="text-gray-600 mt-2">Comprehensive evaluation of your current technology landscape.</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">Digital Transformation</h3>
                                        <p className="text-gray-600 mt-2">Strategic roadmap for digital transformation initiatives.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-8 rounded-2xl shadow-2xl">
                            <h2 className="text-3xl font-semibold text-blue-900 mb-6">Implementation Support</h2>
                            <p className="text-gray-600 mb-6 text-lg">
                                End-to-end support for your technology implementation projects.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">Project Management</h3>
                                        <p className="text-gray-600 mt-2">Professional management of your technology initiatives.</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mt-1">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-blue-900">Change Management</h3>
                                        <p className="text-gray-600 mt-2">Smooth transition and adoption of new technologies.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-12">
                        <Link to="/contact#contact" 
                           className="bg-blue-900 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-800 transition duration-300">
                            Get Expert Consultation
                        </Link>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default ITConsulting;
